/*
 * Lib Module Postlinks
 */

class Postlink extends LibModule {

    DOMReady() {
        const self = this;
        $(document).on('click', '[data-postlink]:not([data-confirm])', function(e) {
            e.preventDefault();
            self.launch($(this));
        });
    }
    
    /**
     * Launch a postlink
     * @param el postlink element {a}
     */
    launch(el) {
        $('<form />').attr({
            method: 'POST',
            action: el.data('postlink') || ''
        }).append(((function() {

            const holder = $('<div />').addClass('hidden');
            const postDataId = el.data('postdata-id');

            if (postDataId) {
                const postData = Lib.Util.getOption('data.postlinkdata.' + postDataId);
                if (postData) {
                    // TODO: Add a recursive function to support unlimited levels of postdata - Milan 20180709
                    $.each(postData, function(name, val) {
                        if (typeof val === 'object') {
                            $.each(val, function(subname, subval) {
                                $('<input />').attr({
                                    type: 'text',
                                    name: `${name}[${subname}]`,
                                    value: subval
                                }).appendTo(holder);
                            });
                        } else {
                            $('<input />').attr({
                                type: 'text',
                                name: name,
                                value: val
                            }).appendTo(holder);
                        }
                    });
                }
            }

            return holder;

        }))()).appendTo($('body')).submit();
    }
}

Lib.Postlink = new Postlink;
